import React, { Component } from 'react';
import './style.css';

// Compontents
import Navbar from '../../Components/Navbar/Navbar';
import AddProjects from '../../Components/AddProject/AddProjects';

// Section
import SkillsSections from '../../Sections/Skills/SkillsSections';
import AboutSection from '../../Sections/About/AboutSection';
import ServicesSection from '../../Sections/Services/ServicesSection';
import PortfolioSection from '../../Sections/Portfolio/PortfolioSection';
import BannerSection from '../../Sections/Banner/BannerSection';
import WorkSection from '../../Sections/Work/WorkSection';
import { logEventPage } from '../../Components/Firebase';

const items = [
  { target: 'about', name: 'About' },
  { target: 'work', name: 'Work Experience' },
  { target: 'portfolio', name: 'Portfolio' },
];
class App extends Component {
  componentDidMount() {
    const baseURL = process.env.PUBLIC_URL;
    window.scrollTo(0, 0);
    console.log('URL : ', baseURL);
    logEventPage('Home page', 'start');
  }

  render() {
    return (
      <>
        {/* <Loading /> */}
        <Navbar items={items} trans={true} />
        <BannerSection />
        <AboutSection />
        <WorkSection />
        <SkillsSections />
        {/* <ServicesSection /> */}
        <PortfolioSection />
        {/* <AddProjects /> */}
      </>
    );
  }
}

export default App;
